<div class="premio-1">
    <div class="circle-container">
        <img src="../../assets/10-img@2x.png" alt="slot1">
    </div>
    <div class="text-1">
        X 3
    </div>
    <div class="text-2">
        10% de descuento en tus<br>compras durante el Buen Fin.
    </div>
</div>
<div class="premio-1" style="margin-left: 19vw;">
    <div class="circle-container">
        <img src="../../assets/15-img@2x.png" alt="slot1">
    </div>
    <div class="text-1">
        X 3
    </div>
    <div class="text-2">
        15% de descuento en<br>compras en línea.
    </div>
</div>
<div class="premio-1" style="margin-left: 29vw;">
    <div class="circle-container">
        <img src="../../assets/bb_bf.png" alt="slot1">
    </div>
    <div class="text-1">
        X 3
    </div>
    <div class="text-2">
        Un cubrebocas de tela<br>con filtro quirúrgico.
    </div>
</div>
<a (click)="goToHome()">
    <div class="text-3-container">
        <img class="arrow-left" src="../../assets/arrow-right.png" alt="logo">
        <span class="text-3">
            Regresar al inicio
        </span>
    </div>
</a>
<a (click)="goToGame()">
    <div class="text-4-container">
        <span class="text-4">
            Iniciar el juego
        </span>
        <img class="arrow-right" src="../../assets/arrow-right.png" alt="logo">
    </div>
</a>
